module.exports = __webpack_public_path__ + "img/bg01.c3222fab.svg";